/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleDetail
 */
export interface ScheduleDetail {
    /**
     * 
     * @type {Date}
     * @memberof ScheduleDetail
     */
    end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleDetail
     */
    start?: Date;
}

/**
 * Check if a given object implements the ScheduleDetail interface.
 */
export function instanceOfScheduleDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScheduleDetailFromJSON(json: any): ScheduleDetail {
    return ScheduleDetailFromJSONTyped(json, false);
}

export function ScheduleDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'start': !exists(json, 'start') ? undefined : (new Date(json['start'])),
    };
}

export function ScheduleDetailToJSON(value?: ScheduleDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'start': value.start === undefined ? undefined : (value.start.toISOString()),
    };
}

